// @flow
import React, { Fragment } from 'react';
import i18n from 'i18n-js';

import styles from './monitorDataPanel.css';
import type { MONITOR_TYPE } from '../../../types/monitors';
import Cell from '../../DataTable/Cells/Text';

type MonitorDataPanelPropTypes = {
  monitor: MONITOR_TYPE,
  updateMonitor: Function,
};

const MonitorDataPanel = ({ monitor, updateMonitor }: MonitorDataPanelPropTypes) => (
  <Fragment>
    <p className={styles.label}>{ i18n.t('labels.name', { count: 1 }) }</p>
    <p className={styles.data}>
      <Cell
        value={
          `${monitor && monitor.first_name}`
        }
        editable
        original={monitor}
        onChange={(original, first_name) => updateMonitor({ id: original.id, first_name })}
      />
    </p>
    <p className={styles.label}>Apellido: </p>
    <p className={styles.data}>
      <Cell
        value={
          `${monitor && monitor.last_name}`
        }
        editable
        original={monitor}
        onChange={(original, last_name) => updateMonitor({ id: original.id, last_name })}
      />
    </p>
    <br />
    <p className={styles.label}>Teléfono: </p>
    <p className={styles.data}>
      <Cell
        value={
          `${monitor && monitor.phone}`
        }
        editable
        original={monitor}
        onChange={(original, phone) => updateMonitor({ id: original.id, phone })}
      />
    </p>

  </Fragment>

);

export default MonitorDataPanel;



// WEBPACK FOOTER //
// ./src/scripts/components/MonitorCard/MonitorDataPanel/index.jsx